<template>
  <div class="flex items-center justify-between gap-20">
    <!-- Default: an optional leading icon + the title. Consumers can override the whole title area via the default slot (e.g. a metal image + name + symbol). -->
    <slot>
      <div class="flex items-center gap-8">
        <RevIllustration
          v-if="icon"
          :src="icon"
          :width="26"
          :height="26"
          alt=""
          aria-hidden="true"
        />
        <h2 class="raw-heading-3">
          {{ title }}
        </h2>
      </div>
    </slot>
    <!-- Trailing controls. `#actions` lands before the ✕ (e.g. the article's
             extend button); an empty slot renders nothing, so consumers without one
             are unchanged — a single-child flex row with `gap-8` is a no-op. -->
    <div class="flex shrink-0 items-center gap-8">
      <slot name="actions" />
      <button
        type="button"
        class="raw-glass rounded-full z-10 flex h-36 w-36 shrink-0 items-center justify-center text-[--raw-verydarkgrey] transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] active:border-[white] active:bg-[white] md:hover:border-[white] md:hover:bg-[white]"
        :aria-label="i18n(translations.closeLabel)"
        @click="$emit('close')"
      >
        <svg
          width="10"
          height="10"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M1 1L11 11M11 1L1 11"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from '~/scopes/campaign/components/UI/DetailHeader.translations'

defineProps<{ title?: string; icon?: string }>()
defineEmits<{ close: [] }>()

const i18n = useI18n()
</script>
